export const setOpenKeys = (data) => ({
  type: 'SET_OPEN_KEYS',
  data
})

export const setActiveMenuItemKey = (data) => ({
  type: 'SET_ACTIVE_MENU_ITEM_KEY',
  data
})


// WEBPACK FOOTER //
// ./src/redux/actions/SideMenu/SidemenuActions.js